export default {
    projects: [],
    searchQuery: "",
    favorites: []
};
